import { isEqual } from 'lodash'
export default function(compareValue, cellValue) {
  if (!compareValue?.toLowerCase || !cellValue?.toLowerCase) {
    return isEqual(compareValue, cellValue)
  }
  return compareValue.toLowerCase().localeCompare(cellValue.toLowerCase())

}
